const locationRedirectModalButton = document.querySelector<HTMLDivElement>(
    "#user-search-location-modal .btn-ladies-primary",
)

const modalBackground = document.createElement("div")
modalBackground.textContent = ""
modalBackground.classList.add("modal-backdrop", "in")

function showRedirectWarningModal() {
    $("#user-search-location-modal").modal("show")
}
function hideRedirectWarningModal() {
    $("#user-search-location-modal").modal("hide")
}

export function registerLocationRedirectModal() {
    const savedSearchesItemCard = document.querySelectorAll<HTMLDivElement>(
        "div[data-location-search='mobile'] a.user-search-entry",
    )

    if (!savedSearchesItemCard) {
        return
    }

    if (SiteInfo.isMobileVersion) {
        for (const card of savedSearchesItemCard) {
            card.addEventListener("click", (event) => {
                event.preventDefault()
            })
        }
        return
    }

    for (const card of savedSearchesItemCard) {
        card.addEventListener("click", (event) => {
            event.preventDefault()

            const htmlElement = event.currentTarget as HTMLElement

            const href = htmlElement.getAttribute("href") || ""

            registerLocationRedirectModalButton(href)
            showRedirectWarningModal()
        })
    }
}

function registerLocationRedirectModalButton(href: string) {
    const dismissButton = document.querySelector<HTMLDivElement>("#user-search-location-modal .icon-modal-close")

    if (!locationRedirectModalButton) return

    dismissButton?.addEventListener("click", () => {
        hideRedirectWarningModal()
    })

    locationRedirectModalButton.addEventListener("click", () => {
        hideRedirectWarningModal()

        window.location.href = removeLocationFromHref(href)
    })
}

function removeLocationFromHref(href: string): string {
    const url = new URL(href, window.location.origin)
    url.pathname = url.pathname.replace("/standort", "")

    return url.toString()
}
